import { httpClient } from '@/services/http/httpClient'

type CompleteWorkflowStepParams = {
  ideaId: string
  stepId: string
  tasks: {
    id: string
    title: string
    completed: boolean
    endDate?: Date
  }[]
}

export async function completeWorkflowStep({
  ideaId,
  stepId,
  tasks,
}: CompleteWorkflowStepParams): Promise<void> {
  await httpClient.put(`/ideas/funnel/steps/${stepId}/approve`, {
    ideaId,
    tasks,
  })
}
